import { NullableMeasure } from '@e2m-customer-portal/shared';
import clsx from 'clsx';
import { format, formatRFC3339 } from 'date-fns';
import { MarketLocationType, Maybe } from 'generated/graphql';
import { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FormattedValue } from '../formatted-value/FormattedValue';

interface MasterDataItemProps {
  children?: ReactNode;
  header: string;
  body?: null | string | number | Date | NullableMeasure;
  mainType?: Maybe<MarketLocationType>;
  linkedMarketLocationBody?: null | string | number | NullableMeasure;
  linkedType?: Maybe<MarketLocationType>;
  unit?: string;
  className?: string;
}

export function MasterDataItem({
  children,
  header,
  body,
  mainType,
  linkedMarketLocationBody,
  linkedType,
  unit,
  className,
}: Readonly<MasterDataItemProps>): ReactElement<MasterDataItemProps> {
  const [t] = useTranslation();

  if (linkedMarketLocationBody) {
    return (
      <div className={clsx('ml-3.5 p-0', className)}>
        <div className="text-grey-400 pb-1 text-xs leading-normal">{header}</div>
        <div className="block text-sm leading-normal">
          {children ??
            (body instanceof Date ? (
              <time className="whitespace-pre-line font-semibold" dateTime={formatRFC3339(body)}>
                {format(body, t('SHARED_DATE_TIME_FORMAT_SHORT'))}
              </time>
            ) : (
              <>
                <p className="font-semibold text-blue-grey-200 text-xs m-0 p-0">{t(`SHARED_${mainType}`)}: </p>
                <FormattedValue className="whitespace-pre-line font-semibold inline" value={body} unit={unit} />
              </>
            ))}
        </div>
        <div className="block text-sm leading-normal">
          {children ?? (
            <>
              <p className="font-semibold text-blue-grey-200 text-xs m-0 p-0">{t(`SHARED_${linkedType}`)}: </p>
              <FormattedValue
                className="whitespace-pre-line font-semibold inline"
                value={linkedMarketLocationBody}
                unit={unit}
              />
            </>
          )}
        </div>
      </div>
    );
  } else
    return (
      <div className={clsx('ml-3.5 p-0', className)}>
        <div className="text-grey-400 pb-1 text-xs leading-normal">{header}</div>
        <div className="inline-block text-sm leading-normal">
          {children ??
            (body instanceof Date ? (
              <time className="whitespace-pre-line font-semibold" dateTime={formatRFC3339(body)}>
                {format(body, t('SHARED_DATE_TIME_FORMAT_SHORT'))}
              </time>
            ) : (
              <FormattedValue className="whitespace-pre-line font-semibold" value={body} unit={unit} />
            ))}
        </div>
      </div>
    );
}
